import cn from 'classnames'
import { IFormMarketShare } from 'legacy/lut/classes/models/partner360/IFormMarketShare'
import { formatMoneyInteger } from 'legacy/lut/components/widgets/public/partner360/helpers/formatMoneyInteger'

import { Translation } from 'cng-common/features/translations/components/translation'
import { TPopupHorizontal } from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'

import styles from '../../CategoryPlanning.module.scss'
import { actualsColor, quotaColor, targetsColor } from '../../config'
import { getDivisor } from '../../helpers/getDivisor'
import { getFractionDigits } from '../../helpers/getFractionDigits'
import { getGtmPoints } from '../../helpers/getGtmPoints'

export const fieldWrapper = (
  fieldValue: number,
  year: number,
  isRetail: boolean,
  marketShareData: IFormMarketShare[],
  fieldType: 'targets' | 'actuals' | 'quota' = 'targets',
  isShowZero: boolean = false,
  fractionDigits: number = 0,
  rounding: string = '',
  tip: string = ''
) => {
  const divisor = getDivisor(rounding)
  const roundingFractionDigits = getFractionDigits(rounding)
  fractionDigits =
    !fractionDigits && roundingFractionDigits ? roundingFractionDigits : fractionDigits

  let formattedValue = formatMoneyInteger(fieldValue, fractionDigits, divisor)
  if (!isShowZero && fieldValue === null) {
    formattedValue = '-'
  }

  let isUseColor = false
  let color = targetsColor
  switch (fieldType) {
    case 'actuals': {
      color = actualsColor
      isUseColor = true
      break
    }
    case 'quota': {
      color = quotaColor
      isUseColor = true
      break
    }
    case 'targets':
    default: {
      // Not use custom Color
      break
    }
  }

  if (!isRetail) {
    return (
      <Tooltip
        inline
        tipContent={() => (
          <div className={styles.productLineTip}>
            <span>{tip}</span>
          </div>
        )}
        horizontalStartPosition={TPopupHorizontal.Center}
        horizontalDirection={TPopupHorizontal.Center}
        disabled={!tip}
      >
        {!isUseColor ? (
          <div className={cn({ [styles.valueTip]: tip })}>{formattedValue}</div>
        ) : (
          <div className={cn({ [styles.valueTip]: tip })} style={{ color: color }}>
            {formattedValue}
          </div>
        )}
      </Tooltip>
    )
  } else {
    const gtmOnline = getGtmPoints(marketShareData, fieldValue, year, 'Online')
    const gtmInstore = getGtmPoints(marketShareData, fieldValue, year, 'Instore')
    const gtmOnlineFormatted = formatMoneyInteger(gtmOnline, fractionDigits, divisor)
    const gtmInstoreFormatted = formatMoneyInteger(gtmInstore, fractionDigits, divisor)

    return (
      <Tooltip
        tipContent={() => (
          <span className={styles.tipContent}>
            <span className={styles.tipLine}>
              <Translation text="jbp-gtm-priorities-online-tip" span />
              {gtmOnlineFormatted}
            </span>
            <br />
            <span className={styles.tipLine}>
              <Translation text="jbp-gtm-priorities-instore-tip" span />
              {gtmInstoreFormatted}
            </span>
          </span>
        )}
      >
        {!isUseColor ? formattedValue : <div style={{ color: color }}>{formattedValue}</div>}
      </Tooltip>
    )
  }
}
